// Routes — composants de redirection, chargeurs et pages partagés par plusieurs
// fichiers de routes (lot 7.6 : App.tsx éclaté par domaine).
import { Navigate, useLocation, useParams } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useAuth } from "../contexts/AuthContext";
import { segmentOrg } from "../lib/urls";
import { cibleDependDeLOrg, cibleRedirection, type RedirectionHeritee as EntreeRedirection } from "./redirections";

// Lot 9.0 (2026-10-18) : LE composant de redirection héritée — rend une entrée
// de la table routes/redirections.ts (paramètres capturés substitués dans la
// cible, query d'origine conservée : ?tab=documents circule dans des emails
// déjà envoyés). Remplace RedirectAvecQuery et les composants à paramètres
// qui vivaient dans chaque fichier de routes.
export function RedirectionHeritee({ entree }: { entree: EntreeRedirection }) {
  const params = useParams();
  const { pathname, search } = useLocation();
  const { user, isLoading } = useAuth();
  // Lot 9.1 : une cible du niveau organisation (`{slug}`) attend la session —
  // un visiteur non connecté se connecte d'abord et revient sur l'ancienne URL.
  if (cibleDependDeLOrg(entree)) {
    if (isLoading) return <LoadingFallback />;
    if (!user) return <Navigate to={`/login?returnTo=${encodeURIComponent(pathname + search)}`} replace />;
  }
  const contexte = { slug: user ? segmentOrg(user.organisationSlug, user.organisationId) : null };
  return <Navigate to={cibleRedirection(entree, params, search, contexte)} replace />;
}
// Composant de chargement
export function LoadingFallback() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <CircularProgress sx={{ color: "#4BB7A5" }} />
    </Box>
  );
}